// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"5ac31355","420":"0eb25360","803":"2fc8c7ed"}[chunkId] + ".chunk.css";
};